import React from 'react';

export default function Input({
  label, name, value, onChange, type = 'text',
  placeholder, error, required = false, style, dir = 'auto',
}) {
  return (
    <div style={{ marginBottom: 'var(--sp-lg)', ...style }}>
      {label && (
        <label
          htmlFor={name}
          style={{
            display: 'block',
            marginBottom: 'var(--sp-xs)',
            fontSize: 'var(--font-size-base)',
            color: error ? 'var(--color-danger-text)' : 'var(--color-text-secondary)',
            fontWeight: '600',
          }}
        >
          {label}
          {required && <span style={{ color: 'var(--color-danger)' }}> *</span>}
        </label>
      )}
      <input
        id={name}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        dir={dir}
        style={{
          width: '100%',
          padding: '10px 12px',
          border: `1px solid ${error ? 'var(--color-danger)' : 'var(--color-border)'}`,
          borderRadius: 'var(--radius-sm)',
          fontSize: 'var(--font-size-base)',
          boxSizing: 'border-box',
          outline: 'none',
          transition: 'border-color var(--transition-fast)',
        }}
        onFocus={(e) => {
          e.target.style.borderColor = 'var(--color-primary)';
        }}
        onBlur={(e) => {
          e.target.style.borderColor = error ? 'var(--color-danger)' : 'var(--color-border)';
        }}
      />
      {error && (
        <div style={{
          fontSize: 'var(--font-size-xs)',
          color: 'var(--color-danger-text)',
          marginTop: 'var(--sp-xs)',
        }}>{error}</div>
      )}
    </div>
  );
}
